module.exports = __webpack_public_path__ + "img/video_game1.d4200261.png";